import { SensorLatest } from '../../services/api';

export enum MetricOptions {
  Raw = 'Raw',
  Hourly = 'Hourly',
  Daily = 'Daily',
}
export const getCommonLocId = (
  selectedSensorIds: string[],
  sensorsById: Map<string, SensorLatest>
) => {
  // Get all locations and filter out empty strings and duplicates
  const allLocations: string[] = Array.from(
    new Set(
      selectedSensorIds
        .map((id: string) => sensorsById.get(id)?.location ?? '')
        .filter((loc: string) => loc !== '')
    )
  );

  // If no locations or only one location, return it
  if (allLocations.length === 0) return '';
  if (allLocations.length === 1) return allLocations[0];

  // Find common prefix among all locations
  let commonPrefix: string = allLocations[0];

  for (let i = 1; i < allLocations.length; i++) {
    let j = 0;
    while (
      j < commonPrefix.length &&
      j < allLocations[i].length &&
      commonPrefix[j] === allLocations[i][j]
    ) {
      j++;
    }
    commonPrefix = commonPrefix.substring(0, j);

    // Stop early if no common prefix
    if (commonPrefix === '') break;
  }

  // Trim to last complete segment (include everything up to and including the last '#')
  const lastHash: number = commonPrefix.lastIndexOf('#');
  if (lastHash >= 0) {
    commonPrefix = commonPrefix.substring(0, lastHash + 1);
  }

  // If result is just '#', return it as is
  if (commonPrefix === '#' || commonPrefix === '') {
    return commonPrefix || '#';
  }

  // Remove trailing '#' if there's more content before it
  if (commonPrefix.endsWith('#') && commonPrefix.length > 1) {
    commonPrefix = commonPrefix.substring(0, commonPrefix.length - 1);
  }

  return commonPrefix || allLocations[0];
};
